var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 90C36.8609 90 26.178 85.575 18.3015 77.6985C10.425 69.822 6 59.1391 6 48C6 36.8609 10.425 26.178 18.3015 18.3015C26.178 10.425 36.8609 6 48 6C59.1391 6 69.822 10.425 77.6985 18.3015C85.575 26.178 90 36.8609 90 48C90 59.1391 85.575 69.822 77.6985 77.6985C69.822 85.575 59.1391 90 48 90ZM48 96C60.7304 96 72.9394 90.9429 81.9411 81.9411C90.9429 72.9394 96 60.7304 96 48C96 35.2696 90.9429 23.0606 81.9411 14.0589C72.9394 5.05713 60.7304 0 48 0C35.2696 0 23.0606 5.05713 14.0589 14.0589C5.05713 23.0606 0 35.2696 0 48C0 60.7304 5.05713 72.9394 14.0589 81.9411C23.0606 90.9429 35.2696 96 48 96Z",
    fill: "url(#paint0_linear_1249_669)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8191 29.8202C65.7764 29.8616 65.7363 29.9057 65.6991 29.9522L44.8611 56.5022L32.3031 43.9382C31.4501 43.1433 30.3218 42.7106 29.156 42.7312C27.9902 42.7517 26.8778 43.224 26.0534 44.0485C25.2289 44.873 24.7566 45.9853 24.7361 47.1511C24.7155 48.3169 25.1482 49.4452 25.9431 50.2982L41.8191 66.1802C42.2468 66.6071 42.7561 66.9435 43.3166 67.1693C43.8771 67.3952 44.4774 67.5058 45.0816 67.4946C45.6858 67.4834 46.2815 67.3506 46.8333 67.1042C47.385 66.8577 47.8815 66.5027 48.2931 66.0602L72.2451 36.1202C73.0607 35.2642 73.5066 34.1216 73.4865 32.9394C73.4663 31.7573 72.9817 30.6305 72.1374 29.8028C71.2932 28.9751 70.157 28.5129 68.9747 28.5161C67.7924 28.5194 66.6588 28.9878 65.8191 29.8202Z",
    fill: "url(#paint1_linear_1249_669)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1249_669",
    x1: 14.08,
    y1: 10.24,
    x2: 119.04,
    y2: 113.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3898FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1249_669",
    x1: 49.1112,
    y1: 28.5161,
    x2: 49.1112,
    y2: 67.4953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3898FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7F5FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccess);
export default __webpack_public_path__ + "static/media/icon-success.e1f66b3c.svg";
export { ForwardRef as ReactComponent };